<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Documentos dos Planos</span>
        <e-help-tooltip :text="$constants.tooltips.planos.DocumentosPlanos" />
        <!-- <e-help-tooltip  :text="$constants.tooltips.matriculas.criarAluno" /> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn color="success" @click="criarDocumento" class="mr-2">Novo Documento</v-btn>
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="documentosList"
          :loading="carregando"
          :items-per-page="10"
          :custom-filter="dataTableFilter"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody v-if="items.length === 0">
              <tr>
                <td :colspan="table.headers.length" class="text-center pa-4">
                  Nenhum documento encontrado para o ano atual
                </td>
              </tr>
            </tbody>

            <tbody v-else is="transition-group" name="scroll-x-transition" duration="150">
              <tr v-for="doc in items" :key="doc.id">
                <td>{{ doc.id }}</td>
                <td>{{ doc.disciplina?.descricao }}</td>
                <td>{{ doc.etapa.descricao }}</td>
                <td>
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip
                      v-for="(s, index) in doc.series"
                      :key="index"
                      label
                      color="green"
                      x-small
                    >
                      {{ s.descricao.toUpperCase() }}
                    </v-chip>
                  </div>
                </td>

                <td>
                  <v-btn
                    x-small
                    class="ml-1"
                    color="blue-grey lighten-3"
                    @click="editarDocumento(doc)"
                  >
                    <v-icon small>fa fa-edit</v-icon>
                  </v-btn>
                  <v-btn x-small color="error" class="ml-1" @click="deletarDocumento(doc)">
                    <v-icon small>fa fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
          <template v-slot:no-data>
            <div class="text-center pa-4">
              <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
              <div class="text-h6 grey--text text--lighten-1 mt-2">Nenhum documento encontrado</div>
              <div class="grey--text">Não há documentos cadastrados para o ano atual</div>
            </div>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="carregarDocumentos"
          :search="search"
        />
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";

export default {
  data() {
    return {
      documentosList: [],
      carregando: false,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Componente curricular", value: "disciplina" },
          { text: "Etapa", value: "etapa" },
          { text: "Etapas", value: "series" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
      dataTableFilter,
    };
  },
  async mounted() {
    await this.carregarDocumentos(this.paginate.current_page);
  },
  watch: {
    async search(val) {
      if (val.length > 2) await this.carregarDocumentos(0, val);
      if (!val) await this.carregarDocumentos(0);
    },
  },
  methods: {
    async carregarDocumentos(pageNumber = 0, query = null) {
      this.carregando = true;
      try {
        const response = await this.$services.documentosPlanosService.listarPaginado(
          pageNumber,
          query
        );
        this.paginate = response;
        this.documentosList = response.data;
      } catch (e) {
        this.$handleError(e);
      } finally {
        this.carregando = false;
      }
    },
    criarDocumento() {
      this.$router.push({ name: "documentosPlanos.create" });
    },
    editarDocumento(documento) {
      this.$router.push({ name: "documentosPlanos.edit", params: { documentoId: documento.id } });
    },
    deletarDocumento(documento) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este documento?",
        confirmationCode: documento.id,
        confirmationMessage: `Digite <strong>${documento.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => this.$modals.close(),
            props: { color: "warning", small: true },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Apagando documento...");
              try {
                await this.$services.documentosPlanosService.deletar(documento.id);
                this.$toast.success("Documento apagado com sucesso!");
                await this.carregarDocumentos(this.paginate.current_page);
              } catch (e) {
                this.$handleError(e);
              }
              this.$loaderService.close();
            },
            props: { color: "error", small: true },
          },
        ],
      });
    },
  },
};
</script>
